import { createSlice } from "@reduxjs/toolkit";
import { ApiCallStatus, ApiResourceState } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { updateAccessTokenWithRefreshTokenAsync } from "@myRedux/session/refreshTokenSlice";
import { logout } from "@myRedux/session/sessionSlice";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { getResourceFromResourceFuncRel } from "@myRedux/appAsyncThunkUtilities";
import { UserResource } from "@myRedux/user/userSlice";
import { setUserDisplayNameAsync } from "@myRedux/user/userDisplayNameSlice";

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiResourceState<UserResource>;

export const getUserFromAccessTokenAsync = getResourceFromResourceFuncRel(
  'user/getUserFromSession',
  'user',
  (state) => state.api.api.value!);

export const userFromSessionSlice = createSlice({
  name: 'userFromSessionSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserFromAccessTokenAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(getUserFromAccessTokenAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = action.payload
      })
      .addCase(getUserFromAccessTokenAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      })
      .addCase(updateAccessTokenWithRefreshTokenAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Idle;
        state.value = null;
      })
      .addCase(logout, (state) => {
        state.status = ApiCallStatus.Idle;
        state.value = null;
      })
      .addCase(setUserDisplayNameAsync.fulfilled, (state, action) => {
        if (state.value?.displayUserName) {
          state.value.displayUserName = action.meta.arg.resourceToPut.userName;
        }
      });
  },
});

export const selectLoggedInUserInfo = (state: RootState) => state.user.loggedInUser;

export default userFromSessionSlice.reducer;